import { routes } from 'data'
import { routes as oldRouts } from 'old/data'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { getAdminVersion } from 'utils'

export const App = () => {
    const router = createBrowserRouter(getAdminVersion() === 'v2' ? routes : oldRouts)
    return <RouterProvider router={router} />
}
